module.exports = __webpack_public_path__ + "img/the-knot-25.981050d0.svg";